/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Merge_Event_Group_Group_Type_Audio_DescriptionInputs */

const en_merge_event_group_group_type_audio_description = /** @type {(inputs: Merge_Event_Group_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Description`)
};

const fr_merge_event_group_group_type_audio_description = /** @type {(inputs: Merge_Event_Group_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description audio`)
};

const de_merge_event_group_group_type_audio_description = /** @type {(inputs: Merge_Event_Group_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibung`)
};

const it_merge_event_group_group_type_audio_description = /** @type {(inputs: Merge_Event_Group_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione audio`)
};

const ru_merge_event_group_group_type_audio_description = /** @type {(inputs: Merge_Event_Group_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиоописание`)
};

const es_merge_event_group_group_type_audio_description = /** @type {(inputs: Merge_Event_Group_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción de audio`)
};

const zh_cn2_merge_event_group_group_type_audio_description = /** @type {(inputs: Merge_Event_Group_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频描述`)
};

const ja_merge_event_group_group_type_audio_description = /** @type {(inputs: Merge_Event_Group_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ説明`)
};

const hi_merge_event_group_group_type_audio_description = /** @type {(inputs: Merge_Event_Group_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण`)
};

const pt_pt2_merge_event_group_group_type_audio_description = /** @type {(inputs: Merge_Event_Group_Group_Type_Audio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição em áudio`)
};

/**
* | output |
* | --- |
* | "Audio Description" |
*
* @param {Merge_Event_Group_Group_Type_Audio_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const merge_event_group_group_type_audio_description = /** @type {((inputs?: Merge_Event_Group_Group_Type_Audio_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Merge_Event_Group_Group_Type_Audio_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_merge_event_group_group_type_audio_description(inputs)
	if (locale === "de") return de_merge_event_group_group_type_audio_description(inputs)
	if (locale === "it") return it_merge_event_group_group_type_audio_description(inputs)
	if (locale === "ru") return ru_merge_event_group_group_type_audio_description(inputs)
	if (locale === "es") return es_merge_event_group_group_type_audio_description(inputs)
	if (locale === "zh-CN") return zh_cn2_merge_event_group_group_type_audio_description(inputs)
	if (locale === "ja") return ja_merge_event_group_group_type_audio_description(inputs)
	if (locale === "hi") return hi_merge_event_group_group_type_audio_description(inputs)
	if (locale === "pt-PT") return pt_pt2_merge_event_group_group_type_audio_description(inputs)
	return en_merge_event_group_group_type_audio_description(inputs)
});